// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nlp-designer__button {
    padding: 4px 8px;
    border: 1px solid #26a69a;
    border-radius: 8px;
    position: relative;
    background: #26a69a;
}

.nlp-designer__button-label {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/app/nlpDesigner/components/button/Button.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".nlp-designer__button {\r\n    padding: 4px 8px;\r\n    border: 1px solid #26a69a;\r\n    border-radius: 8px;\r\n    position: relative;\r\n    background: #26a69a;\r\n}\r\n\r\n.nlp-designer__button-label {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #ffffff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
